import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Switch,
  InputNumber,
  Card,
  Skeleton,
  Form,
  Input,
  notification,
} from "antd";
import {
  DeleteFilled,
  EditFilled,
  EyeFilled,
  CloseOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
  InboxOutlined,
} from "@ant-design/icons";
import { Typography, Upload } from "antd";
import { Link } from "react-router-dom";
import {
  viewAllCoursesAction,
  addCourseAction,
  deleteCourseAction,
} from "../../redux/actions/courseActions";
import { connect } from "react-redux";
import { Editor } from "@tinymce/tinymce-react";
import Dashboard from "../../components/common/layout/Dashboard";
import {url} from "../../helpers/apiCall";

// dotenv.config({path:"../../../.env"});
const { Title } = Typography;
const { TextArea } = Input;

const Home = ({
  viewAllCoursesAction,
  courseState,
  addCourseAction,
  newCourse,
  deleteCourseAction,
  deletedCourse,
}) => {
  const [form] = Form.useForm();
  const { confirm } = Modal;

  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [editCourseModal, setEditCourseModal] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [courseData, setNewCourseData] = useState({});
  const [editCourseData, setEditCourseData] = useState({});

  const [imageSelected, setImageSelected] = useState("");

  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const normFile = (e) => {
    console.log("Upload event:", e);

    if (Array.isArray(e)) {
      return e;
    }

    return e && e.fileList;
  };

  const showModal = () => {
    setVisible(true);
  };

  const onChange = (checked) => {
    console.log("switch changed: ", checked);
  };
  const handleOk = (e) => {
    e.preventDefault();
    setConfirmLoading(true);
    addCourseAction(courseData);
  };

  const handleCancel = () => {
    setVisible(false);
    setEditCourseModal(false);
  };

  const showDelete = (course) => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you want to delete "${course}"?`,
      onOk() {
        deleteCourseAction(course);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  useEffect(() => {
    viewAllCoursesAction();
    if (courseState.allCoursesData) {
      setLoading(false);
    }

    if (newCourse.newCourseData) {
      setVisible(false);
      setConfirmLoading(false);
      // uploadImage(courseData.uploaded);
      setNewCourseData({});
      form.resetFields();
      notification.success({
        message: "New course has been created successfully",
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else if (newCourse.newCourseError) {
      setConfirmLoading(false);
      setNewCourseData({});
      notification.error({
        message: "Can not create the course. Please try again",
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
    if (deletedCourse.deletedCourseData) {
      notification.success({ message: "Course deleted successfully" });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
    if (deletedCourse.deletedCourseError) {
      notification.error({
        message: "Can not delete the course. Please try again",
      });
    }
  }, [newCourse, deletedCourse]);

  return (
    <>
      {/* New course modal */}
      <Modal
        title="New course"
        visible={visible}
        onOk={(e) => handleOk(e)}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        okText="Create"
        okButtonProps={{ htmlType: "submit" }}
      >
        <Form
          form={form}
          layout="vertical"
          hideRequiredMark
          className="mb-4"
          onFinish={onFinish}
        >
          <Form.Item
            label="Course Title"
            name="courseName"
            rules={[{ required: true, message: "Please provide course name" }]}
          >
            <Input
              size="large"
              type="text"
              placeholder="Course Title"
              onChange={(e) =>
                setNewCourseData({ ...courseData, name: e.target.value })
              }
            />
          </Form.Item>
          <Form.Item
            label="Course Description"
            name="courseDescription"
            rules={[
              {
                required: true,
                max: 150,
                message:
                  "Description is required & should be of 150 chars maximum",
              },
            ]}
          >
            <TextArea
              rows={4}
              placeholder="Course Description"
              onChange={(e) =>
                setNewCourseData({ ...courseData, description: e.target.value })
              }
            />
          </Form.Item>

          <Form.Item label="Inspirations:" name="insp1">
            <Input
              size="large"
              type="text"
              placeholder=""
              onChange={(e) =>
                setNewCourseData({ ...courseData, insp1: e.target.value })
              }
            />
          </Form.Item>
          <Form.Item name="insp2">
            <Input
              size="large"
              type="text"
              placeholder=""
              onChange={(e) =>
                setNewCourseData({ ...courseData, insp2: e.target.value })
              }
            />
          </Form.Item>

          <Form.Item name="insp3">
            <Input
              size="large"
              type="text"
              placeholder=""
              onChange={(e) =>
                setNewCourseData({ ...courseData, insp3: e.target.value })
              }
            />
          </Form.Item>
          <Form.Item label="Dragger">
            <Form.Item
              name="dragger"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              noStyle
            >
              {/* <image cloudName="drgtkm4m9" public_id="" /> */}
              <Upload.Dragger name="files" action={url+"/upload/image"} 
              onChange={(picture) =>
                setNewCourseData({ ...courseData,image:picture.file?.response?.secure_url})
              }>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for a single or bulk upload.
                </p>
              </Upload.Dragger>
            </Form.Item>
          </Form.Item>
          <div style={{ display: "flex", width: "100%" }}>
            <Form.Item
              label="Course Duration in Weeks"
              style={{ width: "50%" }}
            >
              <InputNumber
                size="large"
                min={1}
                max={100}
                defaultValue={1}
                onChange={(value) =>
                  setNewCourseData({ ...courseData, duration: value })
                }
              />
            </Form.Item>
            <Form.Item
              label="Publish Course Public"
              name="visible"
              valuePropName="checked"
            >
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                defaultChecked={false}
                onChange={(checked) =>
                  setNewCourseData({ ...courseData, isVisible: checked })
                }
              />
            </Form.Item>
          </div>
        </Form>
      </Modal>

      <Title>Courses</Title>
      <Button
        type="primary"
        size="large"
        // className="container-100"
        htmlType="submit"
        onClick={showModal}
      >
        Add new course
      </Button>
      <div className="flex-wrap-row">
        {courseState.allCoursesData?.data.map((course, index) => {
          return (
            <Card
              key={index}
              actions={[
                <DeleteFilled
                  key="delete"
                  onClick={() => showDelete(course.name)}
                />,
                <Link
                  to={`/dashboard/courses/edit?name=${
                    course.name
                  }&description=${course.description}&insp1=${
                    !course.inspirations[0] ? "" : course.inspirations[0]
                  }&insp2=${
                    !course.inspirations[1] ? "" : course.inspirations[1]
                  }&insp3=${
                    !course.inspirations[2] ? "" : course.inspirations[2]
                  }&duration=${course.duration}&visible=${course.is_visible}`}
                >
                  <EditFilled key="edit" />
                </Link>,
                <Link
                  to={`/dashboard/courses/${course.name}/module-management`}
                >
                  <EyeFilled key="view" />
                </Link>,
              ]}
              title={
                <Skeleton loading={loading} avatar active>
                  <div style={{ display: "flex" }}>
                    <Link
                      to={`/dashboard/courses/${course.name}/module-management`}
                    >
                      {course.name}
                    </Link>

                    {course.is_visible ? (
                      <div
                        style={{
                          margin: "8px",
                          height: "10px",
                          width: "10px",
                          background: "green",
                        }}
                      ></div>
                    ) : (
                      <div
                        style={{
                          margin: "8px",
                          height: "10px",
                          width: "10px",
                          background: "red",
                        }}
                      ></div>
                    )}
                  </div>
                </Skeleton>
              }
              style={{ width: 300, margin: 10 }}
            >
              <Skeleton loading={loading} avatar active>
                <p>{course.description}</p>
              </Skeleton>
            </Card>
          );
        })}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    courseState: state.courses.allCourses,
    newCourse: state.courses.newCourse,
    deletedCourse: state.courses.deletedCourse,
  };
};

export default connect(mapStateToProps, {
  viewAllCoursesAction,
  addCourseAction,
  deleteCourseAction,
})(Home);
